module.exports = __webpack_public_path__ + "static/media/progress-boomer.77b19b27.svg";